(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-minimal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      format = format || ('€{' + '{amount_with_comma_separator}}');
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      function fmt(number, precision, thousands, decimal) {
        precision = precision == null ? 2 : precision;
        thousands = thousands == null ? ',' : thousands;
        decimal = decimal == null ? '.' : decimal;
        if (isNaN(number) || number == null) return '0';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        var c = parts[1] ? decimal + parts[1] : '';
        return dollars + c;
      }
      var match = format.match(placeholder);
      var value = '';
      switch (match ? match[1] : 'amount') {
        case 'amount': value = fmt(cents, 2); break;
        case 'amount_no_decimals': value = fmt(cents, 0); break;
        case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
        case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
        case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
        default: value = fmt(cents, 2);
      }
      return format.replace(placeholder, value);
    }

    function stripTags(html) {
      var d = document.createElement('div');
      d.innerHTML = html;
      return d.textContent || '';
    }

    function initSection(root) {
      if (!root || root.dataset.pmReady) return;
      root.dataset.pmReady = '1';

      var dataEl = root.querySelector('[data-pm-product]');
      var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], options: [] };
      var stage = root.querySelector('[data-stage]');
      var allFrames = Array.prototype.slice.call(root.querySelectorAll('[data-frame]'));
      var thumbItems = Array.prototype.slice.call(root.querySelectorAll('[data-thumb-item]'));
      var counter = root.querySelector('[data-counter]');
      var frames = allFrames.slice();
      var current = 0;

      /* ---------------- Stage / frames ---------------- */
      function visibleFrames() {
        return allFrames.filter(function (f) { return !f.classList.contains('is-hidden'); });
      }

      function show(index) {
        frames = visibleFrames();
        if (!frames.length) return;
        current = ((index % frames.length) + frames.length) % frames.length;
        allFrames.forEach(function (f) { f.classList.remove('is-active'); });
        var active = frames[current];
        active.classList.add('is-active');
        var id = active.dataset.mediaId;
        root.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t.dataset.mediaId === id ? 'true' : 'false');
        });
        var activeThumb = root.querySelector('[data-thumb][aria-current="true"]');
        var list = root.querySelector('[data-thumbs]');
        if (activeThumb && list && list.scrollWidth > list.clientWidth) {
          var lr = list.getBoundingClientRect(), tr = activeThumb.getBoundingClientRect();
          if (tr.left < lr.left || tr.right > lr.right) {
            list.scrollBy({ left: tr.left - lr.left - 8, behavior: 'smooth' });
          }
        }
        if (counter) {
          var pad = function (n) { return (n < 10 ? '0' : '') + n; };
          counter.textContent = pad(current + 1) + ' / ' + pad(frames.length);
        }
        var draggable = frames.length > 1 && active.dataset.type === 'image';
        stage.classList.toggle('is-draggable', draggable);
        var hint = root.querySelector('[data-hint]');
        if (hint) hint.style.display = frames.length > 1 || active.dataset.type === 'model' ? '' : 'none';
        allFrames.forEach(function (f) {
          var v = f.querySelector('video');
          if (v) { if (f === active) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } }
        });
      }

      function showByMediaId(id) {
        frames = visibleFrames();
        for (var i = 0; i < frames.length; i++) {
          if (String(frames[i].dataset.mediaId) === String(id)) { show(i); return true; }
        }
        return false;
      }

      root.querySelectorAll('[data-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          showByMediaId(btn.dataset.mediaId);
          stage.classList.add('has-interacted');
        });
      });

      /* Drag to rotate: trascinare l'intera larghezza dello stage = un giro completo */
      var dragging = false, startX = 0, startIndex = 0, pointerId = null, moved = false;

      stage.addEventListener('pointerdown', function (e) {
        frames = visibleFrames();
        var active = frames[current];
        if (!active || active.dataset.type !== 'image' || frames.length < 2) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true; moved = false;
        startX = e.clientX; startIndex = current; pointerId = e.pointerId;
        stage.classList.add('is-dragging');
        try { stage.setPointerCapture(pointerId); } catch (err) {}
      });

      stage.addEventListener('pointermove', function (e) {
        if (!dragging || e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        var imageFrames = frames.filter(function (f) { return f.dataset.type === 'image'; });
        var pxPerFrame = Math.max(6, stage.clientWidth / Math.max(imageFrames.length, 1));
        var steps = Math.round(dx / pxPerFrame);
        if (steps !== 0) moved = true;
        // trascinando verso sinistra l'oggetto "ruota" in avanti (invertibile dalle impostazioni)
        var target = data.invertDrag ? startIndex + steps : startIndex - steps;
        // salta i frame non-immagine durante la rotazione
        var n = frames.length, guard = 0;
        var idx = ((target % n) + n) % n;
        while (frames[idx].dataset.type !== 'image' && guard < n) {
          idx = ((idx + (steps > 0 ? -1 : 1)) % n + n) % n; guard++;
        }
        if (idx !== current) show(idx);
        if (moved) stage.classList.add('has-interacted');
      });

      function endDrag(e) {
        if (!dragging || (e && e.pointerId !== pointerId)) return;
        dragging = false;
        stage.classList.remove('is-dragging');
        try { stage.releasePointerCapture(pointerId); } catch (err) {}
      }
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);
      stage.addEventListener('lostpointercapture', endDrag);

      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(current + 1); stage.classList.add('has-interacted'); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(current - 1); stage.classList.add('has-interacted'); e.preventDefault(); }
      });

      /* 3D models: carica la UI di Shopify per model-viewer */
      if (root.querySelector('[data-type="model"]') && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: function (errors) {
            if (errors) return;
            root.querySelectorAll('model-viewer').forEach(function (mv) {
              try { new window.Shopify.ModelViewerUI(mv); } catch (err) {}
            });
          }
        }]);
      }

      /* ---------------- Variants ---------------- */
      var form = root.querySelector('[data-pm-form]');
      var idInput = root.querySelector('[data-variant-id]');
      var atc = root.querySelector('[data-atc]');
      var atcLabel = root.querySelector('[data-atc-label]');
      var atcPrice = root.querySelector('[data-atc-price]');
      var priceCurrent = root.querySelector('[data-price-current]');
      var priceCompare = root.querySelector('[data-price-compare]');
      var priceBadge = root.querySelector('[data-price-badge]');
      var msg = root.querySelector('[data-msg]');
      var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));

      var colorNames = ['color', 'colour', 'colore', 'colori', 'farbe', 'couleur'];
      var colorIndex = -1;
      fieldsets.forEach(function (fs, i) {
        if (colorNames.indexOf(fs.dataset.optionName) > -1 && colorIndex < 0) colorIndex = i;
      });
      if (colorIndex < 0 && fieldsets.length) colorIndex = 0;

      function selected() {
        return fieldsets.map(function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }

      function findVariant(sel) {
        if (!fieldsets.length) {
          return data.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || data.variants[0];
        }
        return data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });
      }

      function markAvailability(sel) {
        fieldsets.forEach(function (fs, i) {
          fs.querySelectorAll('[data-value]').forEach(function (wrap) {
            var val = wrap.querySelector('input').value;
            var test = sel.slice(); test[i] = val;
            var ok = data.variants.some(function (v) {
              return v.available && v.options.every(function (o, j) {
                return j === i ? o === val : (j < i ? o === test[j] : true);
              });
            });
            wrap.classList.toggle('is-unavailable', !ok);
          });
        });
      }

      function filterFrames(sel) {
        if (!data.filterByAlt || colorIndex < 0) return;
        var value = (sel[colorIndex] || '').toLowerCase().trim();
        var colorValues = Array.prototype.map.call(
          fieldsets[colorIndex].querySelectorAll('input'),
          function (i) { return i.value.toLowerCase().trim(); }
        );
        var matches = allFrames.filter(function (f) { return f.dataset.alt === value; });
        var useFilter = matches.length > 0;
        allFrames.forEach(function (f) {
          // nasconde solo le immagini "di un altro colore"; quelle con alt generico restano visibili
          var hide = useFilter && colorValues.indexOf(f.dataset.alt) > -1 && f.dataset.alt !== value;
          f.classList.toggle('is-hidden', hide);
        });
        thumbItems.forEach(function (li) {
          var f = allFrames.find(function (fr) { return fr.dataset.mediaId === li.dataset.mediaId; });
          li.classList.toggle('is-hidden', !!(f && f.classList.contains('is-hidden')));
        });
      }

      function setPrice(v) {
        if (!v) return;
        var p = formatMoney(v.price, data.moneyFormat);
        if (priceCurrent) priceCurrent.innerHTML = p;
        if (atcPrice) atcPrice.innerHTML = p;
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceCompare) {
          priceCompare.hidden = !onSale;
          if (onSale) priceCompare.innerHTML = formatMoney(v.compare_at_price, data.moneyFormat);
        }
        if (priceBadge) priceBadge.hidden = !onSale;
      }

      function setButton(v) {
        if (!atc) return;
        if (!v) {
          atc.disabled = true; atcLabel.textContent = data.labels.unavailable;
        } else if (!v.available) {
          atc.disabled = true; atcLabel.textContent = data.labels.soldout;
        } else {
          atc.disabled = false; atcLabel.textContent = data.labels.add;
        }
      }

      function onChange(fromUser) {
        var sel = selected();
        fieldsets.forEach(function (fs, i) {
          var out = fs.querySelector('[data-selected-value]');
          if (out) out.textContent = sel[i] || '';
        });
        var v = findVariant(sel);
        markAvailability(sel);
        filterFrames(sel);
        setPrice(v);
        setButton(v);
        if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
        if (v) {
          idInput.value = v.id;
          var shown = false;
          if (v.featured_media && v.featured_media.id) shown = showByMediaId(v.featured_media.id);
          if (!shown) show(0);
          if (fromUser && data.updateUrl && window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
        } else {
          show(0);
        }
      }

      fieldsets.forEach(function (fs) {
        fs.addEventListener('change', function () { onChange(true); });
      });

      /* ---------------- Quantity ---------------- */
      root.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var input = root.querySelector('input[name="quantity"]');
          var n = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
          input.value = n;
        });
      });

      /* ---------------- Add to cart (AJAX opzionale) ---------------- */
      if (form && data.ajax) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc.disabled) return;
          atc.setAttribute('aria-busy', 'true');
          var fd = new FormData(form);
          var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root_url + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.body.description || res.body.message || 'Error');
              atcLabel.textContent = data.labels.added;
              setTimeout(function () { setButton(findVariant(selected())); }, 2200);
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: res.body }));
              // Aggiorna il contatore del carrello (temi Dawn e derivati)
              return fetch(root_url + '?sections=cart-icon-bubble')
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (s) {
                  var el = document.getElementById('cart-icon-bubble');
                  if (!s || !s['cart-icon-bubble'] || !el) return;
                  var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
                  var inner = doc.querySelector('.shopify-section');
                  if (inner) el.innerHTML = inner.innerHTML;
                })
                .catch(function () {});
            })
            .catch(function (err) {
              if (msg) { msg.textContent = stripTags(err.message); msg.classList.add('is-error'); }
            })
            .finally(function () { atc.removeAttribute('aria-busy'); });
        });
      }

      onChange(false);
    }

    function initAll() {
      document.querySelectorAll('.pm[data-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.pm[data-section]');
      if (el) initSection(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
